import React, { useState, useEffect } from "react";
import { useCheckIsAuthorizedQuery } from "features/api/auth/authApiSlice";
import { useNavigate } from "react-router-dom";
import "./login.scss";
import { Spinner } from "react-bootstrap";
import { useReports } from "hooks/useReports";
import { completeLocalStorageData } from "utils/userDataUtiles";
import { useRole } from "hooks/useRole";
import { UserRole } from "components/Reports/reportAssets/assets";
import PhoneVerification from "./components/PhoneVerification";
import OtpConfirmation from "./components/OtpConfirmation";
import { viewTypes, phoneVerificationResponseType } from "./types/types";

type UserData = {
  id: string;
  userName: string;
  userRoles: string[];
};
const Login: React.FC = () => {
  const [view, setView] = useState<viewTypes>("phoneVerification");
  const [phoneVerificationResponse, setPhoneVerificationResponse] =
    useState<phoneVerificationResponseType>(null);
  const { data: userData, isLoading }: { data: UserData; isLoading: boolean } =
    useCheckIsAuthorizedQuery();
  const navigate = useNavigate();
  const role = useRole();
  const { setselectedRole } = useReports();

  useEffect(() => {
    if (userData !== undefined && view === "phoneVerification") {
      completeLocalStorageData(setselectedRole, userData);
      role !== UserRole.SENIOR_WATCH
        ? navigate("/reports/inprogress")
        : navigate("/reports/followup");
    }
  }, [navigate, userData, view, setselectedRole, role]);

  const getFirstScreen = () => {
    return isLoading ? (
      <div className="loader-container">
        <Spinner animation="border" variant="primary" />
      </div>
    ) : (
      <PhoneVerification
        setView={setView}
        setPhoneVerificationResponse={setPhoneVerificationResponse}
      />
    );
  };

  return (
    <div className="login-wrapper d-flex">
      {view === "phoneVerification" ? (
        getFirstScreen()
      ) : (
        <OtpConfirmation
          phoneVerificationResponse={phoneVerificationResponse}
          setView={setView}
        />
      )}
    </div>
  );
};

export default Login;
